import whyPerksBarContent from '@containers/Home/constants/WhyPerksBarContent';
import { ContainerLayout } from '@layouts';
import { BulletInfoCard } from './components/BulletInfoCard';
import styles from './styles.module.scss';

export const WhyPerksBar = () => (
  <ContainerLayout
    outerContainerClassName={styles.outerContainer}
    innerContainerClassName={styles.innerContainer}
  >
    <div className={styles.contentContainer}>
      <div className={styles.headerText}>
        <h1>Why PerksBar?</h1>
        <span>
          PerksBar revolutionise the way you engage employees, to promote active participation in
          the company’s mission and values.
        </span>
      </div>
      <div className={styles.whyPbContainer}>
        {whyPerksBarContent.map((props) => (
          <BulletInfoCard key={props.title} {...props} />
        ))}
      </div>
    </div>
  </ContainerLayout>
);

WhyPerksBar.displayName = 'WhyPerksBar';

export default WhyPerksBar;
